module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_8004.83db2a48.png";